import React from "react";

const Card = ({ children, className = "", ...props }) => (
  <div
    className={`bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl shadow-xl shadow-black/30 ${className}`}
    {...props}
  >
    {children}
  </div>
);

export default Card;
